import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RiskScoreItem } from '../../../types';
import { individualClientsRiskApi } from '../services';

export interface IndividualClientsDeliveryChannelsFormState {
  itemId?: string;
  item?: RiskScoreItem;
}

const initialState: IndividualClientsDeliveryChannelsFormState = {};

export const individualClientsDeliveryChannelsFormSlice = createSlice({
  name: 'individualClientsDeliveryChannels',
  initialState,
  reducers: {
    clearIndividualDeliveryChannelFormState: (state) => {
      state.itemId = undefined;
      state.item = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      individualClientsRiskApi.endpoints.getIndividualDeliveryChannel
        .matchFulfilled,
      (state, action: PayloadAction<{ data: RiskScoreItem }>) => {
        state.item = action.payload.data;
        state.itemId = action.payload.data.id;
      },
    );
  },
});

export const { clearIndividualDeliveryChannelFormState } =
  individualClientsDeliveryChannelsFormSlice.actions;

export default individualClientsDeliveryChannelsFormSlice.reducer;
